import { render } from "./ForumListItem.vue?vue&type=template&id=5edcee16&scoped=true"
import script from "./ForumListItem.vue?vue&type=script&lang=js"
export * from "./ForumListItem.vue?vue&type=script&lang=js"

import "./ForumListItem.vue?vue&type=style&index=0&id=5edcee16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edcee16"]])

export default __exports__